'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _urlLocations = require('../../../../routes/urlLocations');

var _Icons = require('../../../Icons');

var _Icons2 = _interopRequireDefault(_Icons);

var _styled = require('../styled');

var _styled2 = _interopRequireDefault(_styled);

var _ComingSoonLabel = require('../../../ComingSoonLabel');

var _ComingSoonLabel2 = _interopRequireDefault(_ComingSoonLabel);

var _isSp = require('../../../../utils/isSp');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MobileMenuList = function MobileMenuList(_ref) {
  var userType = _ref.userType,
      userTheme = _ref.userTheme,
      unread = _ref.unread,
      isAdminPlatform = _ref.isAdminPlatform,
      setLogoutModalVisible = _ref.setLogoutModalVisible,
      user = _ref.user,
      onBurgerClick = _ref.onBurgerClick,
      spPlatformConfig = _ref.spPlatformConfig,
      theme = _ref.theme,
      sidebarComponent = _ref.sidebarComponent;
  var profileUrl = isAdminPlatform ? _urlLocations.adminUserProfile : _urlLocations.userProfile;
  var iconStyles = {
    color: (0, _isSp.isSp)() ? '#1A1A1A' : '#D3D4D9'
  };
  var isSpCheck = (0, _isSp.isSp)();
  var accentColor = spPlatformConfig ? spPlatformConfig.accentColor : '#1496af';
  return userType ? _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_styled2.default.MobileMenuItem, {
    isSpCheck: isSpCheck,
    accentColor: accentColor
  }, _react2.default.createElement(_styled2.default.Sider, {
    isSpCheck: isSpCheck,
    accentColor: accentColor
  }, sidebarComponent)), _react2.default.createElement('div', {
    style: {
      marginLeft: '16px'
    }
  }, user && user.givenName && user.familyName && _react2.default.createElement(_styled2.default.MobileMenuItem, {
    userTheme: userTheme,
    regular: true
  }, _react2.default.createElement(_Icons2.default.user, {
    style: iconStyles
  }), ' ', user.givenName, ' ', user.familyName), _react2.default.createElement('div', {
    style: {
      marginLeft: '30px'
    }
  }, _react2.default.createElement(_styled2.default.MobileMenuItem, {
    userTheme: userTheme,
    accentColor: accentColor,
    isSpCheck: isSpCheck
  }, _react2.default.createElement(_styled2.default.NavLink, {
    onClick: onBurgerClick,
    activeClassName: 'active',
    accentColor: accentColor,
    isSpCheck: isSpCheck,
    to: profileUrl
  }, 'profile')), _react2.default.createElement(_styled2.default.MobileMenuItem, {
    onClick: function onClick() {
      return setLogoutModalVisible(true);
    }
  }, _react2.default.createElement(_styled2.default.LinkLike, {
    userTheme: userTheme
  }, 'SIGN OUT'))))) : _react2.default.createElement(_react.Fragment, null, !spPlatformConfig && _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_styled2.default.MobileMenuItem, {
    userTheme: userTheme
  }, _react2.default.createElement(_styled2.default.NavLink, {
    onClick: onBurgerClick,
    activeClassName: 'active',
    to: _urlLocations.partners
  }, _react2.default.createElement(_Icons2.default.handBag, null), ' Partners')), _react2.default.createElement(_styled2.default.MobileMenuItem, {
    userTheme: userTheme
  }, _react2.default.createElement(_styled2.default.NavLink, {
    onClick: onBurgerClick,
    activeClassName: 'active',
    to: _urlLocations.about
  }, _react2.default.createElement(_Icons2.default.info, null), ' about finbursa'))), _react2.default.createElement(_styled2.default.MobileMenuItem, {
    userTheme: userTheme
  }, _react2.default.createElement(_styled2.default.NavLink, {
    onClick: onBurgerClick,
    activeClassName: 'active',
    to: _urlLocations.login
  }, _react2.default.createElement(_Icons2.default.user, null), ' Login')), _react2.default.createElement(_styled2.default.StyledHr, null), _react2.default.createElement(_styled2.default.MobileMenuItem, {
    userTheme: userTheme
  }, _react2.default.createElement(_ComingSoonLabel2.default, null, 'Coming Soon')), _react2.default.createElement(_styled2.default.MobileMenuItem, {
    disabled: true
  }, _react2.default.createElement(_styled2.default.NavLink, {
    disabled: true,
    to: '#'
  }, _react2.default.createElement(_Icons2.default.card, null), 'Investor club')), !spPlatformConfig && _react2.default.createElement(_styled2.default.MobileMenuItem, {
    disabled: true
  }, _react2.default.createElement(_styled2.default.NavLink, {
    disabled: true,
    to: '#'
  }, _react2.default.createElement(_Icons2.default.members, null), 'Strategic member')));
};

exports.default = (0, _styledComponents.withTheme)(MobileMenuList);